import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { SapiService } from '../services/sapi.service';
import { DataLayerService } from '../services/datalayer.service';
import { Guid } from 'guid-typescript';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { CampaignService } from '../services/campaign.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { LogoComponent } from '../logo/logo.component';


@Component({
  selector: 'app-secuityquestionredirect',
  templateUrl: './secuityquestionredirect.component.html',
  styleUrls: ['./secuityquestionredirect.component.css'],
  standalone: true,
  imports: [CommonModule,LogoComponent]
})
export class SecuityquestionredirectComponent implements OnInit {

  isDefalutMessage=true;
  campaignCookieName: string="user_campaign";
  showHeader: boolean = false;
  displayText: string = "We are currently verifying your security questions. Please wait a moment.";


  constructor(private readonly spinner: NgxSpinnerService,
              private readonly sapiService: SapiService,
              private readonly dataLayerService: DataLayerService,
              private readonly cookieService: CookieService,
              private readonly campaignService: CampaignService,
              private readonly oauthService: OAuthService,
              private readonly router: Router
            ) { }

  ngOnInit(): void {
    const solUrl = localStorage.getItem('SolRegisterUrl');
    if (solUrl) {
      localStorage.removeItem('SolRegisterUrl');
      localStorage.removeItem('SapiVisitUrl');
      localStorage.removeItem('OnLoadCheck');
      localStorage.removeItem('loginFired');
      localStorage.removeItem('tempToken');
      this.router.navigateByUrl('/portal/home');
      return;
    }

    const isEmbeddedInIframe = !!globalThis.frameElement;
    if(!isEmbeddedInIframe){
      this.showHeader = true;
      setTimeout(()=>{
        this.redirectToB2C();
      }, 5000);
    }else{
      this.fecthEventFromSapi();
    }
  }



  fecthEventFromSapi() {
    this.sapiService.fetchEventFromSapi().subscribe({
      next: (data: any) => {


          if(data){
            globalThis.top.location.href = '/sq-redirect';
          }else{
            setTimeout(() => {
              this.fecthEventFromSapi();


            }, 5000);


          }

      }
    })
  }


  redirectToB2C() {
    this.dataLayerService.dataLayerCallback(true,'New User Register Successfully',sessionStorage.getItem('userEmail'),sessionStorage.getItem('userPhoneNumber'));
    localStorage.removeItem('SplRegiterUrl');
    localStorage.removeItem('RegisterUrl');
    localStorage.removeItem('BranchRegisterUrl');
    this.login();
  }


  login() {
    this.isDefalutMessage=false;
    localStorage.removeItem('loginFired');
    this.spinner.show();
    this.azureAdlogin(true);
  }

  azureAdlogin(isRegistrationSuccess: boolean) {
    setTimeout(() => this.spinner.show(), 50);
    localStorage.removeItem('tempToken');

    let submissionId = this.cookieService.get('submissionId') || '';
    let submissionCode = isRegistrationSuccess
        ? '0df6b091-5d71-4f75-a6df-2d6a016e3709'
        : Guid.create().toString();
    const branchUserCheck = sessionStorage.getItem('IsAssociatedWithBranch') === 'true';
    const campaignCookie = this.cookieService.get(this.campaignCookieName);

    if (campaignCookie) {
        this.campaignService.getActiveCampaign('', campaignCookie).subscribe({
          next:  (data: any) => {
            const utm_id = data.campaignUtmId;
            const campaignLinkedPage = data.campaignLinkedPage;
            const tileHighlightId = data.tileHighlightId || '';
            const highlightParts: string[] = tileHighlightId ? tileHighlightId.split("#") : ['', ''];
            const highlightParam1 = highlightParts[0] || '';
            const highlightParam2 = highlightParts[1] || '';
            sessionStorage.setItem("productId",highlightParam1)
            sessionStorage.setItem("categoryId",highlightParam2)
            const linkedCampaignList: string[] = [
                '/portal/home', '/portal/dashboard', '/portal/account',
                '/portal/offers', '/portal/budget', '/portal/profile', '/portal/faq', '/portal/setting'
            ];

            if (
                utm_id &&
                campaignLinkedPage &&
                linkedCampaignList.includes(campaignLinkedPage)
            ) {
                this.oauthService.redirectUri = globalThis.location.origin + campaignLinkedPage;
            }

            this.oauthService.initLoginFlow('', {
                submissionId,
                ccAppUrl: globalThis.location.origin,
                submissionCode,
                instrumentationKey: environment.appInsights.instrumentationKey,
                utm_id,
            });
          }, 
          error: (err: HttpErrorResponse) => {
          console.error(err);
         }
        });
    } else if (branchUserCheck) {
        this.oauthService.redirectUri = globalThis.location.origin + '/portal/dashboard';
        this.oauthService.initLoginFlow('', {
            submissionId,
            ccAppUrl: globalThis.location.origin,
            submissionCode,
            instrumentationKey: environment.appInsights.instrumentationKey,
            utm_source: 'branches',
            login_Count: 1,
        });
    } else {
        this.oauthService.initLoginFlow('', {
            submissionId,
            ccAppUrl: globalThis.location.origin,
            submissionCode,
            instrumentationKey: environment.appInsights.instrumentationKey
        });
    }
   }

  }
